<template>
  <div>
    <SampleSearchForm
      ref="sampleSearchForm"
      :listForm="searchList"
      @handlerSearch="onSearch"
      @clear-search="clearSearch"
    />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
      @sort-change="sortChange"
    >
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
          row.code
        }}</span>
      </template>
      <!-- 采用结果 -->
      <template #isUseSlot="{ row }">
        <div>
          <span>
            {{ row.isUse ? (row.isUse === 'YES' ? '采用' : '不采用') : '' }}
          </span>
          <el-tooltip
            v-if="row.reason"
            effect="dark"
            :content="row.reason"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
      <!-- 状态 -->
      <template #statusSlot="{ row }">
        <div>
          <span>{{ row.statusName }}</span>
          <el-button
            type="text"
            v-if="['REJECT', 'LEADER_REJECT'].includes(row.status) && row.createBy === userInfo.id"
            @click="toUpdate(row, 'update')"
            class="sample-btn"
            v-hasPermission="'outside-warehouse-manage/outside-query-update'"
            >修改</el-button
          >
          <el-tooltip
            v-if="row.status === 'REJECT' || row.status === 'LEADER_REJECT'"
            effect="dark"
            :content="row.checkRemark || row.leadApprovalOpinion"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
      <!-- 明细状态 -->
      <template #detailSlot="{ row }">
        <div>
          <span>{{ row.detailStatusName }}</span>
          <el-button
            v-if="row.detailId && $store.getters.userSupplier.customerId !== '1'"
            style="margin-left: 10px"
            type="text"
            @click="ckeckDetail(row)"
            >查看明细</el-button
          >
        </div>
      </template>
    </CommonTable>

    <!-- 弹框 -->
    <el-dialog center top="5vh" :visible.sync="dialogVisible" width="1200px">
      <OutsideApplySample
        v-if="dialogVisible && status === 'update'"
        ref="outsideApplySample"
        :status="status"
        @on-success="getList"
        @cancel-btn="dialogVisible = false"
      />
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" :detailId="detailId" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import OutsideApplySample from '@/components/OutsideApplySample';
import OutsideSample from '@/components/OutsideSample';
import dayjs from 'dayjs';
export default {
  name: 'outside-query',
  components: { CommonTable, SampleSearchForm, OutsideApplySample, OutsideSample },
  props: {},
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
          {
            tag: 'DictSelect',
            type: 'cml_oorder_status',
            label: '状态',
            prop: 'status',
            defaultValue: undefined,
            placeholder: '请选择状态',
          },
          {
            tag: 'DictSelect',
            type: 'cml_oorder_detail_status',
            label: '明细状态',
            prop: 'detailStatus',
            defaultValue: undefined,
            placeholder: '请选择状态',
          },
          {
            tag: 'el-input',
            label: '快递单号',
            prop: 'expressNo',
            defaultValue: undefined,
            placeholder: '请输入完整的快递单号',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请开始时间',
            prop: 'createDate',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请结束时间',
            prop: 'createdDateEnd',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
        ],
      },
      listForm: {},
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName', sortable: true },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', sortable: true },
        { label: '申请人', prop: 'createByName' },
        { label: '数量', prop: 'num' },
        { label: '单位', prop: 'unit' },
        { label: '样品类型', prop: 'productTypeName', sortable: true },
        {
          label: '状态',
          prop: 'statusName',
          slotColumn: true,
          slotName: 'statusSlot',
          width: 200,
          sortable: true
        },
        { label: '供应商', prop: 'supplierName', sortable: true },
        {
          label: '明细状态',
          prop: 'detailStatusName',
          slotColumn: true,
          slotName: 'detailSlot',
          width: 150,
        },
        { label: '快递单号', prop: 'expressNo' },
        {
          label: '采用结果',
          prop: 'isUse',
          slotColumn: true,
          slotName: 'isUseSlot',
          width: 150,
          sortable: true
        },
      ],
      tableDataTab: {},
      dialogVisible: false,
      userInfo: {},
      allUserData: [],
      status: '',
      id: '',
      detailId: ''
    };
  },
  created() {},
  mounted() {
    // 获取用户登录信息
    this.userInfo = this.$store.getters.userSelf.user;
    this.getList();
    this.getAllUser();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    getAllUser() {
      // 添加申请人条件
      this.$http.setting.getUserListAll({ customerId: '0' }).then(res => {
        const item = {
          tag: 'el-select',
          label: '申请人',
          prop: 'demandStaff',
          defaultValue: undefined,
          placeholder: '请输入申请人名称',
          options: res.data.map(item => {
            return {
              label: item.loginName,
              value: item.id,
            };
          }),
        };
        if (['2', '1'].includes(this.$store.getters.userSelf.user.adminType)) {
          this.searchList.list.push(item);
        }
      });
    },
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      if(params.data.createDate && params.data.createdDateEnd && dayjs(params.data.createDate).diff(dayjs(params.data.createdDateEnd)) > 0) {
        this.$message.error('申请开始时间不能晚于申请结束时间');
        return;
      }
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getList(params)
        .then(result => {
          this.tableDataTab = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 修改
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.detailId = '';
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    cancelBtn() {
      this.dialogVisible = false;
    },
    ckeckDetail(row) {
      this.status = 'detail';
      this.id = row.id;
      this.detailId = row.detailId;
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    clearSearch() {
      this.$refs.CommonTable.clearSort();
      this.tableParamTab.orderBy = '';
      this.tableParamTab.data = {};
      this.listForm = {};
      this.getList();
    },
    sortChange (val) {
      const sortList = {
        productName: 'a.product_name',
        createDate: 'a.create_date',
        productTypeName: 'a.product_type',
        statusName: 'a.status',
        supplierName: 'b.supplier_name',
        isUse: 'b.is_use',
      }
      const str = val.split(' ');
      this.tableParamTab.orderBy = sortList[str[0]] ? sortList[str[0]] + ' ' + str[1] : val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.sample-btn {
  cursor: pointer;
  color: #AB0033;
  margin: 0 7px;
}
.sample-info {
  display: flex;
  padding: 5px 0;
  img {
    margin-right: 5px;
  }
  img,
  div {
    span {
      color: #AB0033;
    }
  }
}
.product-info-box {
  height: 200px;
}
</style>
